


















import Vue from 'vue'

export default Vue.extend({
  name: 'NotFoundPage',
  components: {},
  data: () => ({
  }),
  computed: {
    requestedUrl () {
      return this.$route.query.requestedUrl
    },
    isLoggedIn () {
      return !!this.$store.getters.identity.idToken
    }
  },
  methods: {
  },
  async mounted () {
    await this.$store.commit('setErrorCode', null)
  }
})
